import { Plus } from "lucide-react";

// Section header (Zoho-style): title left, action button right.
export default function AdminHeader({ title, subtitle, action, onAction, actionTestId, count }) {
  return (
    <div className="mb-8 flex items-end justify-between gap-6 flex-wrap">
      <div>
        <div className="flex items-center gap-3">
          <h1 className="font-serif-display text-4xl md:text-5xl">{title}</h1>
          {count !== undefined && (
            <span className="text-sm text-[#D8D6D0]/40 mb-1">({count})</span>
          )}
        </div>
        {subtitle && <p className="text-sm text-[#D8D6D0]/55 mt-2 max-w-2xl">{subtitle}</p>}
      </div>
      {action && (
        <button
          data-testid={actionTestId || "admin-action-btn"}
          onClick={onAction}
          className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#8C1D30] hover:bg-[#7A1829] text-[#F5F3EF] text-xs uppercase tracking-widest transition-colors"
        >
          <Plus className="w-4 h-4" />
          {action}
        </button>
      )}
    </div>
  );
}
